export default {
  // Permanent drawers
  FULL_HEIGHT: 'full-height',
  CLIPPED: 'clipped',
  FLOATING: 'floating',

  // Persistent drawers
  PERSISTENT: 'persistent',
  PERSISTENT_MINI: 'persistent-mini',

  // Temporary
  TEMPORARY: 'temporary',
  TEMPORARY_MINI: 'temporary-mini',
};



// WEBPACK FOOTER //
// ./src/js/Drawers/DrawerTypes.js